module.exports = __webpack_public_path__ + "27db07d3921a40ed82ce9f2ab13a2a19.pdf";